import { NoSymbolIcon } from "@heroicons/react/24/outline";
import type { FunctionComponent } from "react";

const Error404Page: FunctionComponent = () => {
    return (
        <div id="error-page" className="-mt-12 flex h-screen flex-row items-center justify-center gap-0">
            <NoSymbolIcon className="size-32 stroke-red-500" />
            <div className="max-w-80">
                <h1 className="text-4xl font-medium">404 - Page not found</h1>
                <p className="mt-2 leading-5">The requested url does not exist.</p>
            </div>
        </div>
    );
};

export default Error404Page;
